import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualCidades from '../../actions/cidade/determinarPaginaAtualCidades'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoCidades extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualCidades}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualCidade,
    total: state.cidades.total,
    registrosPorPagina: state.registrosPorPaginaCidade
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualCidades }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoCidades)
